import css from 'styles/mint.module.css'
import { formatAddress, openseaHref } from 'utils'
import { Loading, Account, ContractData } from 'types'

type Props = {
  message: string
  account: Account
  isLoading: Loading
  contractData: ContractData
  mintHandler: () => Promise<void>
  whitelistMintHandler: () => Promise<void>
}

export default function Mint({
  message,
  account,
  isLoading,
  contractData,
  mintHandler,
  whitelistMintHandler,
}: Props) {
  const soldOut: boolean =
    !!contractData.maxSupply &&
    !!contractData.totalSupply &&
    contractData.maxSupply === contractData.totalSupply
  return (
    <div className="pd mt">
      <div>
        <h2 className={css.title}>MINT</h2>
        <p>
          Minting MAUP costs <b>{contractData.cost || '—'} MATIC.</b>
        </p>
      </div>
      {account.onWhitelist && !contractData.whitelistClaimed && (
        <div className={`${css.whitelist} mt pd`}>
          <p>
            Your address <b>{formatAddress(account.address)}</b> is eligible for
            free mint! 🎉
          </p>
        </div>
      )}
      <div className={`${css.mint} mt pd`}>
        {soldOut ? (
          <div>
            <h3>The initial sale has sold out.</h3>
          </div>
        ) : (
          <div>
            <h3>MINT: {contractData.cost || '—'} MATIC</h3>
          </div>
        )}
        <div>
          {account.address ? (
            soldOut ? (
              <a href={openseaHref} target="_blank" rel="noopener noreferrer">
                <button className={css.mint_button}>BUY MAUP ON OPENSEA</button>
              </a>
            ) : contractData.whitelistMintEnabled &&
              !contractData.whitelistClaimed &&
              account.onWhitelist ? (
              <button
                data-emoji="🍌"
                onClick={whitelistMintHandler}
                disabled={
                  !!message ||
                  !contractData.whitelistMintEnabled ||
                  isLoading.mint
                }
                className={
                  isLoading.mint ? `${css.mint_button} loader` : css.mint_button
                }
              >
                {isLoading.mint ? '' : 'MINT 1 FREE MAUP'}
              </button>
            ) : (
              <button
                data-emoji="🍌"
                onClick={mintHandler}
                disabled={!!message || contractData.isPaused || isLoading.mint}
                className={
                  isLoading.mint ? `${css.mint_button} loader` : css.mint_button
                }
              >
                {contractData.isPaused
                  ? 'MINTING IS NOT LIVE YET'
                  : isLoading.mint
                  ? ''
                  : 'MINT 1 MAUP'}
              </button>
            )
          ) : (
            <button disabled={true} className={css.mint_button}>
              CONNECT TO MINT MAUP
            </button>
          )}
        </div>
        <div>
          <h3>
            MINTED: {contractData.totalSupply || '—'} /{' '}
            {contractData.maxSupply || '—'}
          </h3>
        </div>
      </div>
    </div>
  )
}
